class AsideMenu {
  constructor() {
    if(document.querySelector('#nav-aside-menu') != null && document.querySelector('#nav-aside-menu') != undefined) {
      this.setEvents();
    }
  }
    
    setEvents() {
 
      var anchor = document.getElementById('nav-aside-menu').getElementsByTagName('a'),
        current = window.location.pathname.split('/')[1];

      for (var i = 0; i < anchor.length; i++) {
        if (anchor[i].href.includes(current)) {
          anchor[i].classList.add("active");
        }
      }
     
    }

  
}
const asideMenu = new AsideMenu();

